<template>
  <PageContent>
    <StepsV2 :step="4" />
    <PanelV2
      type="w6"
      title="Take a selfie with your ID"
      @nextClick="commitData()"
    >
      <template v-slot:title-solt>
        <BdoProgress :step="1" :total="3" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="idCard" @uploadData="uploadData" :photoData="formData" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  // import AppForm from "../forms/ExistingBDOMerchant.val";
  import IdCardUpload from "../pages/common/IdCardUpload.vue";
  import API from "@/api";

  export default {
    name: 'SolePropJ',
    pRouter: 'SolePropI',
    components: {
      IdCardUpload,
      // AppForm,
    },
    data() {
      return {
        formData: {idCardiUrl: ''},
      }
    },
    methods: {
      uploadData(val) {
        this.formData.idCardiUrl = val;
      },
      commitData() {

        // this.$refs.appForm.$refs.appForm.validate((valid) => {

          if (this.formData.idCardiUrl) {
            const data = this.formatCommitData({...this.formData})

            API.addBdoProcess({
              ...data
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          } else {
            this.showMessageTip('Upload your selfie with ID')
          }
        // });
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>
